module.exports = __webpack_public_path__ + "static/media/person_placeholder.8ad65b1f.svg";